import { CURRENT_MONTH, CURRENT_YEAR } from "./misc/constants";
import { useEffect, useState } from "react";

import dayjs from "dayjs";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

export default function useMeetings () {
    const { clientId, platformId } = useParams();
    const [attendees] = useState([]);
    const [events, setEvents] = useState([]);
    const [modalConfig, setModalConfig] = useState({
        open: false,
        row : {}
    });

    const [date, setDate] = useState(new Date(parseInt(CURRENT_YEAR), CURRENT_MONTH));

    const { axiosInstance, loading } = useAxios({ base: "panel" });

    const handleMonthChange = (newDate) => {
        setDate(newDate); 
    };

    const getCalendarEvents = async () => {
        const response = await axiosInstance.get(`/calendar/${platformId}/events`, {
            params: {
                org_id: clientId,
                year  : dayjs(date).year(),
                month : dayjs(date).month() + 1 
            }
        });

        if (response.data) {
            const res = response.data.map((meet) => {
                const start = meet.start ? dayjs(meet.start).toDate() : new Date();
                const end = meet.end ? dayjs(meet.end).toDate() : new Date();

                return {
                    id         : meet.id,
                    title      : meet.title,
                    description: meet.description,
                    start,
                    end,
                    allDay     : false,
                    link       : meet.link || undefined,
                    dateRange  : [dayjs(meet.start), dayjs(meet.end)],
                    hangoutLink: meet.hangoutLink || undefined,
                    attendees  : meet.attendees || [],
                    location   : meet.location || ""
                };
            });
            setEvents(res);
        }
    };

    const toggleModal = (row = {}) => {
        setModalConfig({
            open: !modalConfig.open,
            row
        });
    };

    const handleSlotSelect = (slot) => {
        toggleModal({
            start: slot.start,
            end  : slot.end
        });
    };

    const handleEventSelect = (event) => {
        toggleModal(event);
    };

    useEffect(() => {
        getCalendarEvents();
    }, [date]);

    const disablePastDates = (slotDate) => {
        return dayjs(slotDate).isBefore(dayjs().startOf("day"));
    };

    return {
        loading,
        attendees,
        events,
        date,
        handleMonthChange,
        disablePastDates,
        getCalendarEvents,
        toggleModal,
        handleSlotSelect,
        handleEventSelect,
        modalConfig
    };
}